<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-sugestao') {
            next({ name: 'agro-sugestao-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-sugestao') {
            this.$router.push({ name: 'agro-sugestao-list' });
        }
    },
};
</script>
